import React, {Component} from 'react';
import {connect} from "react-redux";
import {getPatientDetails} from "./actions";
import Details from "../../../../components/Details/Details";
import {setDetailsFilterData, resetDetailsFilterData} from "./../../../AuthWrapper/actions"


class PatientDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            option: {
                noDataText: 'No cases were found for this patient.',
                hideSizePerPage: true,
                sizePerPage: 20,
            },
            patientId:  this.props.match.params.patientId,
            filterData: this.props.filterData
        }
    }
    componentDidMount() {
        document.title = "Patient "+this.state.patientId;
        this.props.getPatientDetails(this.state.patientId);
        this.interval = setInterval(() => this.props.getPatientDetails(this.state.patientId), 7000);

    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleGoBack(location) {
        const page = location.state.page;
        this.props.history.push({
            pathname: page,
            state: {
                filterData: location.state.filterData,
                pageNumber: location.state.pageNumber
            }
        });
        this.props.resetDetailsFilterData();
    }

    handleFilterDataChange(data) {
        this.setState({filterData: data});
        this.props.setDetailsFilterData(data);
    }

    linkToCase (row) {
        this.props.history.push({
            pathname: '/sm-admin/case-details/'+row.bookingId,
            state: {page: '/sm-admin/patients/' + this.state.patientId, pageName: 'Patient Details', filterData: this.props.location}
        });
    }

    render() {
        const header = 'PATIENT ' + this.state.patientId;
        const desc = 'The list of all cases of a patient';
        return !this.props.adminPatientDetails.loading &&
            <Details header={header}
                     desc={desc}
                     handleGoBack={(location) => this.handleGoBack(location)}
                     location={this.props.location}
                     isPatient={true}
                     details={this.props.adminPatientDetails.adminPatientDetails}
                     option={this.state.option}
                     linkToCase={(row) => this.linkToCase(row)}
                     setDetailsFilterData={this.props.setDetailsFilterData}
                     resetDetailsFilterData={this.props.resetDetailsFilterData}
                     filterData={this.state.filterData}
                     handleFilterDataChange={(data) => this.handleFilterDataChange(data)}
        />
    }
}

const mapStateToProps = state => ({
    adminPatientDetails: state.adminPatientDetails,
    filterData: state.auth.detailsFilterData,
});

const mapDispatchToProps = dispatch => {
    return {
        getPatientDetails: (id) => dispatch(getPatientDetails(id)),
        setDetailsFilterData: (data) => dispatch(setDetailsFilterData(data)),
        resetDetailsFilterData: () => dispatch(resetDetailsFilterData()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientDetails);



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/PatientDetails/index.js